export const ALL_CONSULTATION_EMOJIS = [
  '👍',
  '👎',
  '🔧',
  '⭐',
  '✅',
  '❌',
  '⚠️',
  '🔴',
  '🟡',
  '🟢',
] as const;

const CONSULTATION_EMOJI_PATTERN = /^(?:👍|👎|🔧|⭐|✅|❌|⚠️|🔴|🟡|🟢)/;

export const startsWithConsultationEmoji = (text: string): boolean => {
  return CONSULTATION_EMOJI_PATTERN.test(text);
};
